import React, { useEffect } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import confetti from 'canvas-confetti';
import '../styles/InviteSuccess.css';

const InviteSuccess = ({ title, subtitle }) => {
    const { t } = useTranslation();

    useEffect(() => {
        const myLeagueColors = ['#4DA8DA', '#002855', '#8b5cf6', '#4CAF50'];

        const fireConfetti = () => {
            const count = 200;
            const defaults = {
                origin: { y: 1 },
                zIndex: 9999,
                colors: myLeagueColors
            };

            function fire(particleRatio, opts) {
                confetti({
                    ...defaults,
                    ...opts,
                    particleCount: Math.floor(count * particleRatio)
                });
            }

            fire(0.25, {
                spread: 26,
                startVelocity: 55,
            });
            fire(0.2, {
                spread: 60,
            });
            fire(0.35, {
                spread: 100,
                decay: 0.91,
                scalar: 0.8
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 25,
                decay: 0.92,
                scalar: 1.2
            });
            fire(0.1, {
                spread: 120,
                startVelocity: 45,
            });
        };

        fireConfetti();
    }, []);

    return (
        <div className="invite-success-container">
            <div className="invite-success-animation">
                <FaCheckCircle className="invite-success-icon" />
            </div>
            <h3 className="invite-success-title">
                {title || t('invite.successTitle', 'Vítej v lize!')}
            </h3>
            {subtitle && (
                <p className="invite-success-subtitle">
                    {subtitle}
                </p>
            )}
        </div>
    );
};

export default InviteSuccess;